import { useMemo } from 'react';
import { PackQuantitiesWithMultiplier } from '../../../../../../../../../../services/modules/product-colors-packs/product-colors-packs.types';
import useSharedEntities from '../../../../../../../../../shared-entities/hooks/useSharedEntities';
import { OrderView } from '../../../../../../../../ordersView.types';
import useMaxValue from '../../../../../../../hooks/useMaxValue';
import { shouldShowPackStock } from '../../../../../../utils/pack.utils';
import useOrderProductGridContext from '../../../../../contexts/OrderProductGrid.context';

type UsePackMenuItemProps = {
  pack: PackQuantitiesWithMultiplier;
};

const usePackMenuItem = ({ pack }: UsePackMenuItemProps) => {
  const { readMode } = useOrderProductGridContext();
  const { isPublicAccess } = useSharedEntities({});
  const { handleChangeValue } = useMaxValue();

  const stockAvailableAmount = useMemo(() => {
    if (pack.stock && pack.willConsumeStock) {
      return pack.stock.availableAmount ?? undefined;
    }
  }, [pack.stock, pack.willConsumeStock]);

  const showStock = shouldShowPackStock({
    consumeStock: pack.willConsumeStock,
    viewMode: readMode ? OrderView.FINISHED : OrderView.EDIT,
    stockAvailableAmount,
  });

  const max = stockAvailableAmount ?? 999;

  const handleInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    handleChangeValue(event, max);
  };

  return {
    showStock,
    handleInput,
    stockAvailableAmount,
    packItemInReadMode: readMode || isPublicAccess,
  };
};

export default usePackMenuItem;
